module.exports = __webpack_public_path__ + "static/media/project-thumbnail13.379c14b0.jpg";